import React from 'react';
import CustomSelect from "../../../components/common/select/Select";


export default function TPR({
    item,
    budgetRestrictionChange,
                             buyUomSelectChange,
                             applyUomSelectChange,
                             buyTypeSelectChange,
                             selectedSkuNormType,
                             projectCodeMerger,
                             otherDetailsChange,
                             buyFromChange,
                             currentNormChange,
                             buyToChange,
                             applyOnSelectChange,
                             enumData,
                             index,
selectedBuyUom,
selectedAppyOn,
selectedBuyType,
data,
stateselectedSkuNormType,
selectedAppyUom,
isExtended
}) {
  return (
   <>
   <div className="control_panel_upper">
                                <div className="panel_first">
                                  <label>Project Code </label>
                                  <label> {item.ProjectCode} </label>

                                  <div className="cp_inner_second">
                                    <label style={{ paddingTop: "10px" }}>
                                      {" "}
                                  Budget Restriction
                                </label>
                                    <label
                                      className="long_input"
                                      style={{ paddingBottom: "25px" }}
                                    >
                                      {" "}
                                      <input
                                        height="36px"
                                        type="number"
                                        placeholder="Budget Restrictriction"
                                        value={item.BudgetRestriction}
                                        name="budgetRestriction"
                                        onChange={(e) =>
                                          { 
                                            isExtended===true ? void 0 :
                                            budgetRestrictionChange(e, index)
                                          }
                                        }
                                        disabled={isExtended===true?true:false}
                                        style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}:void 0}
                                      />
                                    </label>
                                    <label style={{ paddingBottom: "1vh", paddingTop: '1vw' }}>
                                      {" "}
                                  Buy UOM{" "}
                                      <span className="mandatory_fields">
                                        {item.BuyType ===
                                          "795f46df-01a3-48f9-9143-06ea6c2cf658" ? true : "*"}

                                      </span>{" "}
                                    </label>
                                    <label style={{ paddingBottom: "1.2vh", }}>
                                      <CustomSelect.MySelect
                                        isDisabled={isExtended ===true ? true : item.BuyType ===
                                          "795f46df-01a3-48f9-9143-06ea6c2cf658" ? true : false}
                                        placeholder={item.BuyType ===
                                          "795f46df-01a3-48f9-9143-06ea6c2cf658" ? "" : "Buy Uom"}
                                        options={
                                          item.BuyType ===
                                            "795f46df-01a3-48f9-9143-06ea6c2cf658" ? [] :
                                            enumData
                                              ? enumData
                                                .filter((filter_item) => {
                                                  return (
                                                    filter_item.Type === "BUY_UOM"
                                                  );
                                                })
                                                .filter(validate_item => {
                                                  return item.BuyType === 'e7130818-5d92-4618-8107-efb0d3c623c4' ?
                                                    validate_item.Label !== 'RS-PKR' && validate_item.Label : validate_item.Label
                                                })
                                                .map((map_item) => {
                                                  // log(map_item)
                                                  // map_item.Label !== 'RS-PKR' ?
                                                  return {
                                                    value: map_item.guid,
                                                    label: map_item.Label,
                                                  }
                                                })
                                              : []
                                        }
                                        value={
                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return selectedBuyUom === ""
                                                  ? filter_item.guid ===
                                                  item.BuyUom
                                                  : filter_item.guid ===
                                                  selectedBuyUom;
                                              })
                                              .map((map_item) => {
                                                // log(i)
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                };
                                              })
                                            : void 0
                                        }
                                        // value={detailData!==undefined?  detailData.selectedPromotionType : selectedPromotionType }
                                        onChange={(val) =>
                                          buyUomSelectChange(val.value, index)
                                        }
                                      />
                                    </label>
                                    <label> Apply UOM
                                {(item.ApplyOn !== '47bf77b7-8768-4718-9e42-9a36bc2bfcaf' ||
                                        item.NormType === "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") &&
                                        <span className='mandatory_fields' >*</span>
                                      }
                                    </label>
                                    <label>
                                      <CustomSelect.MySelect
                                        isDisabled={
                                          isExtended ===true ? true :
                                          (item.NormType ===
                                            "2a48252b-4179-4090-98ac-a437728d5ed6" ||
                                            item.BuyType ===
                                            "795f46df-01a3-48f9-9143-06ea6c2cf658") &&
                                            (item.NormType !==
                                              "b2e41bb3-a11d-48f1-b041-b9c04c956e7a")
                                            ? true
                                            : false
                                        }
                                        placeholder={
                                          (item.NormType ===
                                            "2a48252b-4179-4090-98ac-a437728d5ed6" ||
                                            item.BuyType ===
                                            "795f46df-01a3-48f9-9143-06ea6c2cf658") &&
                                            (item.NormType !==
                                              "b2e41bb3-a11d-48f1-b041-b9c04c956e7a")
                                            ? ""
                                            : "Apply Uom"
                                        }
                                        options={
                                          (item.NormType ===
                                            "2a48252b-4179-4090-98ac-a437728d5ed6" ||
                                            item.BuyType ===
                                            "795f46df-01a3-48f9-9143-06ea6c2cf658") &&
                                            (item.NormType !==
                                              "b2e41bb3-a11d-48f1-b041-b9c04c956e7a")
                                            ? []
                                            : enumData
                                              ? enumData
                                                .filter((filter_item) => {
                                                  return (
                                                    filter_item.Type === "APPLY_UOM"
                                                  );
                                                })
                                                .filter((validate_item) => {
                                                  // log(validate_item.guid === 'd1496288-73be-4de8-a615-8d568e8c6b4f' &&
                                                  // validate_item.guid === '8a3e952e-ec37-4b56-b869-be65efaf4ac2' && validate_item)
                                                  return (item.BuyUom === "bcaed8e2-588d-446d-982f-66987e903dd3" ||
                                                    item.BuyUom === "4f031ace-badf-4340-a2e9-dd7363fbc3de"
                                                    ?
                                                    (validate_item.guid === 'd1496288-73be-4de8-a615-8d568e8c6b4f' ||
                                                      validate_item.guid === '8a3e952e-ec37-4b56-b869-be65efaf4ac2') && validate_item
                                                    :
                                                    item.BuyUom === "c5ddb6ef-847e-44fc-9950-debe5a1d3793" &&
                                                      item.NormType === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238"
                                                      ? // kg
                                                      validate_item.guid === 'd2f775a7-5320-4b0b-b3c4-45dd8378bf47' && validate_item
                                                      :
                                                      item.BuyUom === "e907be85-2af9-4ca6-9c94-79dcde6507a1" &&
                                                        item.NormType === "608618a4-50a0-4b2c-bdb1-8eac4e5e3238"
                                                        ? // lt tr
                                                        validate_item.guid === '8f031b99-3e78-4374-88e7-5999a1ee81a7' && validate_item
                                                        : validate_item
                                                  );
                                                })
                                                .map((map_item) => {
                                                  // log(i)
                                                  return {
                                                    value: map_item.guid,
                                                    label: map_item.Label,
                                                  };
                                                })
                                              : []
                                        }
                                        value={
                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return selectedAppyUom === ""
                                                  ? filter_item.guid ===
                                                  item.ApplyUom
                                                  : filter_item.guid ===
                                                  selectedAppyUom;
                                              })
                                              .map((map_item) => {
                                                // log(i)
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                };
                                              })
                                            : void 0
                                        }
                                        // value={detailData!==undefined?  detailData.selectedPromotionType : selectedPromotionType }
                                        onChange={(val) =>
                                          applyUomSelectChange(
                                            val.value,
                                            index
                                          )
                                        }
                                      />
                                    </label>
                                  </div>
                                </div>
                                <div className="panel_first">
                                  <label>Detail of Offer </label>
                                  <label style={{ fontSize: '1em' }} > {!item.DetailOfOffer ? "-" : item.DetailOfOffer} </label>

                                  <div className="cp_inner_second">
                                    <label>
                                      {" "}
                                  Buy Type{" "}
                                      <span className="mandatory_fields">
                                        *
                                  </span>{" "}
                                    </label>
                                    <label className="buyType_class_media">
                                      <CustomSelect.MySelect
                                        className="buyType_select"
                                        placeholder="Buy Type"
                                        isDisabled={isExtended ===true ? true : false}
                                        options={
                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return (
                                                  filter_item.Type === "BUY_TYPE"
                                                );
                                              })
                                              .map((map_item) => {
                                                // log(i)
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                };
                                              })
                                            : []
                                        }
                                        value={
                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return selectedBuyType === ""
                                                  ? filter_item.guid ===
                                                  item.BuyType
                                                  : filter_item.guid ===
                                                  selectedBuyType;
                                              })
                                              .map((map_item) => {
                                                // log(i)
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                };
                                              })
                                            : void 0
                                        }
                                        // value={detailData!==undefined?  detailData.selectedPromotionType : selectedPromotionType }
                                        onChange={(val) =>
                                          buyTypeSelectChange(val.value, index)
                                        }
                                      />
                                    </label>
                                   
                                    <label style={{ paddingTop: "1vw" }}>
                                      {" "}
                                  Norm Type {" "}
                                      <span className="mandatory_fields">
                                        *
                                  </span>{" "}
                                    </label>
                                    <label>
                                      <CustomSelect.MySelect
                                        className="class_for_height"
                                        placeholder="Norm Type"
                                        isDisabled={isExtended ===true ? true :false}
                                        options={
                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return (
                                                  filter_item.Type ===
                                                  "DISCOUNT_TYPE"
                                                );
                                              }).filter(for_freesku => {
                                                return for_freesku.guid !== 'b2e41bb3-a11d-48f1-b041-b9c04c956e7a'
                                              })
                                              .map((map_item) => {
                                                // log(i)
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                };
                                              })
                                            : []
                                        }
                                        value={
                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return selectedSkuNormType === ""
                                                  ? filter_item.guid ===
                                                  item.NormType
                                                  : filter_item.guid ===
                                                  stateselectedSkuNormType;
                                              })
                                              .map((map_item) => {
                                                // log(i)
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                };
                                              })
                                            : void 0
                                        }
                                        // value={detailData!==undefined?  detailData.selectedPromotionType : selectedPromotionType }
                                        onChange={(val) =>
                                          // currentNormTypeChange(val, index)
                                          projectCodeMerger(val, item, index)
                                        }
                                      />
                                    </label>
                                    <label style={item.ApplyOn !== '47bf77b7-8768-4718-9e42-9a36bc2bfcaf' ? { paddingTop: '0.7vw' } : void 0}>
                                      ROI%
                                </label>
                                    <label style={{ paddingTop: "1vh" }}>
                                      {!item.Roi ? 0 : item.Roi}
                                      {/* { item.Roi } */}
                                    </label>
                                  </div>
                                </div>
                                <div className="panel_first">
                                  <label>Other Details </label>
                                  <label>
                                    {" "}
                                    <input
                                      type="text"
                                      className="other_detail_input"
                                      placeholder="Other Details"
                                      onChange={(e) => {isExtended===true ? void 0 :otherDetailsChange(e.target.value, index)}}
                                      name="otherDetails"
                                      value={item.OtherDetails && item.OtherDetails}
                                      disabled={isExtended===true?true:false}
                                      style={isExtended===true?
                                      {cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8,paddingLeft: "0.6vw",
                                        fontFamily: 'Source Sans Pro", sans-serif',
                                        fontSize: "0.9vw",}
                                        :
                                      {
                                        paddingLeft: "0.6vw",
                                        fontFamily: 'Source Sans Pro", sans-serif',
                                        fontSize: "0.9vw",
                                      }}
                                    />
                                  </label>

                                  <div className="cp_second_right">
                                    <div style={{ width: "100%" }}>
                                      <label style={{ paddingBottom: "5.46px" }}>
                                        Buy From{" "}
                                        <span className="mandatory_fields">*</span>{" "}
                                      </label>
                                      <label
                                        className="long_input"
                                        style={{ paddingBottom: "15px" }}
                                      >
                                        <input
                                          type="number"
                                          placeholder="Buy From"
                                          className="other_detail_input"
                                          onChange={(e) =>
                                            {isExtended===true ? void 0 :buyFromChange(e, index)}
                                          }
                                          name="buyFrom"
                                          value={item.BuyFrom}
                                      disabled={isExtended===true?true:false}
                                      style={isExtended===true?
                                      {cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}
                                        :
                                        void 0
                                      }
                                        />
                                      </label>
                                      <label
                                        style={{
                                          paddingBottom: "1vh",
                                          marginTop: "-0.1vw",
                                        }}
                                      >
                                        {" "}
                                    Norm{" "}
                                        <span className="mandatory_fields">
                                          *
                                    </span>{" "}
                                      </label>
                                      <label className="long_input">
                                        <input
                                          type="number"
                                          className="other_detail_input"
                                          onChange={(e) => {
                                            currentNormChange(e, index, item)
                                          }
                                          }
                                          name="norm"
                                          value={item.Norm}
                                      disabled={isExtended===true?true:false}
                                      style={isExtended===true?
                                      {cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8,height: "36px"}
                                        :
                                        { height: "36px" }
                                      }
                                        />
                                      </label>
                                    </div>
                                    <div style={{ width: "100%" }}>
                                      <label style={{ paddingBottom: "5.46px" }}>
                                        {" "}
                                    Buy To{" "}
                                        <span className="mandatory_fields">
                                          *
                                    </span>{" "}
                                      </label>
                                      <label
                                        className="long_input"
                                        style={{ paddingBottom: "15px" }}
                                      >
                                        <input
                                          type="number"
                                          className="other_detail_input"
                                          placeholder="Buy To"
                                          onChange={(e) =>
                                            {isExtended===true ? void 0 :buyToChange(e, index)}
                                          }
                                          value={item.BuyTo}
                                      disabled={isExtended===true?true:false}
                                      style={isExtended===true?
                                      {cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}
                                        :
                                        void 0
                                      }
                                        />
                                      </label>
                                      <label style={{ paddingBottom: "1vh" }}>
                                        {" "}
                                    Apply On
                                    <span className='mandatory_fields' >*</span>
                                      </label>
                                      <label>
                                        {/* {item.NormType==='2a48252b-4179-4090-98ac-a437728d5ed6'?
                                <CustomSelect.MySelect
                                value='47bf77b7-8768-4718-9e42-9a36bc2bfcaf'
                                onChange={(val) => applyOnSelectChange(val.value,index)}

                                />
                                : */}
                                        <CustomSelect.MySelect
                                          placeholder="Apply on"
                                          isDisabled={isExtended===true?true:false}
                                          options={
                                            item.NormType ===
                                              "2a48252b-4179-4090-98ac-a437728d5ed6" ||
                                              item.NormType ===
                                              "b2e41bb3-a11d-48f1-b041-b9c04c956e7a" ||
                                              item.BuyType === "795f46df-01a3-48f9-9143-06ea6c2cf658"
                                              //  item.BuyType ===  "795f46df-01a3-48f9-9143-06ea6c2cf658"
                                              ? []
                                              : enumData
                                                ? enumData
                                                  .filter((filter_item) => {
                                                    return (
                                                      filter_item.Type ===
                                                      "APPLY_ON"
                                                    );
                                                  })
                                                  .filter((validate_item) => {
                                                    // log(validate_item.guid === 'd1496288-73be-4de8-a615-8d568e8c6b4f' &&
                                                    // validate_item.guid === '8a3e952e-ec37-4b56-b869-be65efaf4ac2' && validate_item)
                                                    return (item.BuyUom === "bcaed8e2-588d-446d-982f-66987e903dd3" ||
                                                      item.BuyUom === "4f031ace-badf-4340-a2e9-dd7363fbc3de" ?
                                                      (validate_item.guid === '47bf77b7-8768-4718-9e42-9a36bc2bfcaf' ||
                                                        validate_item.guid === '6a9237fe-dcb2-41dc-88d7-1cc4b3ddfd1c') && validate_item
                                                      :
                                                      item.BuyUom === "c5ddb6ef-847e-44fc-9950-debe5a1d3793" ? // kg
                                                        validate_item.guid === 'ddc4666c-6dc8-427e-a077-e4aa6bfc1273' && validate_item
                                                        :
                                                        item.BuyUom === "e907be85-2af9-4ca6-9c94-79dcde6507a1" ? // lt tr
                                                          validate_item.guid === 'df316d1d-1486-4e37-87a3-f2fb2315d8b0' && validate_item
                                                          : validate_item
                                                    );
                                                  })
                                                  .map((map_item) => {
                                                    // log(map_item);
                                                    return {
                                                      value: map_item.guid,
                                                      label: map_item.Label,
                                                    };
                                                  })
                                                : []
                                          }
                                          value={
                                            enumData
                                              ? enumData
                                                .filter((filter_item) => {
                                                  return selectedAppyOn === ""
                                                    ? filter_item.guid ===
                                                    item.ApplyOn
                                                    : filter_item.guid ===
                                                    selectedAppyOn;
                                                })
                                                .map((map_item) => {
                                                  // log(i)
                                                  return {
                                                    value: map_item.guid,
                                                    label: map_item.Label,
                                                  };
                                                })
                                              : void 0
                                          }
                                          // value={detailData!==undefined?  detailData.selectedPromotionType : selectedPromotionType }
                                          onChange={(val) => {
                                            applyOnSelectChange(
                                              val.value,
                                              index
                                            );
                                          }}
                                        />
                                        {/* } */}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                           
   </>
  );
}
